import DialogFactory from '@kso/ui/lib/Dialog';
import '@kso/ui/lib/Dialog/style.css';
import Index from '@kso/ui/lib/FileCopy';
import '@kso/ui/lib/FileCopy/style.css';
import KSecureTeamTips from '@kso/ui/lib/SecureTeamTips';
import '@kso/ui/lib/SecureTeamTips/style.css';

var index = DialogFactory({
  entry: function entry(_ref) {
    var showSecureTips = _ref.showSecureTips;
    return showSecureTips ? 'KSecureTeamTips' : 'KFileCopy';
  },
  pages: [{
    className: 'k-dialog-page-file-copy',
    width: '822px',
    body: Index,
    footer: null,
    closeOnClickModal: false
  }, {
    className: 'k-dialog-secure-tips',
    width: '420px',
    body: KSecureTeamTips,
    footer: null,
    closeOnClickModal: false
  }]
});

export { index as default };
